"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bucketNameRegexes = {
    lowercaseStartEnd: new RegExp('^[a-z0-9](.*[a-z0-9])?$'),
    lowercaseLettersNumbersDotsHyphens: new RegExp('^[a-z0-9-.]+$'),
    lowercaseLettersNumbersHyphens: new RegExp('^[a-z0-9-]+$'),
    dashSequence: new RegExp('--'),
    ipAddress: new RegExp('^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$')
};
exports.bucketNameRegexes = bucketNameRegexes;
//# sourceMappingURL=SharedRegexes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/portal-shared-lib/build/SharedRegexes.js
// module id = 567
// module chunks = 1